import { download, get, post } from './api';
import routes from './end-points';

export const adminTodoApi = {
  initTodos: (filter) => post(routes.adminTodos.initTodos, filter),
  getTodos: (todoId) => get(routes.adminTodos.getTodo(todoId)),
  saveTodo: (todo) => post(routes.adminTodos.saveTodo, todo),
};
